import { makeStyles } from '../../../styles';
export const useStyles = makeStyles(() => ({
    container: {
        padding: '40px',
        height: '500px',
        display: 'flex',
        alignItems: 'center',
        flexDirection: 'column',
        gap: '30px',
        justifyItems: 'center',
        width: '100%',
    },
}));
//# sourceMappingURL=NoDataOverlay.styles.js.map